import { FeatureFlag } from '@synergy/models';

export const hasFeature = (feature: FeatureFlag): boolean => {
    const featureContent = process.env[`NX_PUBLIC_APP_${feature}`];
    return !!featureContent && featureContent.toLowerCase() === 'true';
};
